// check for cart state change
$('.cart-item .qty').on('change',function(){
  $('#cart-footer .btn-prompt').hide();
  $('[name="checkout"]').prop('disabled',false);
  $('.cart-item').each(function(){
    let $qty = $(this).find('.qty');
    if ( parseInt($qty.val()) !== parseInt($qty.data('initial-value'))) {
      $('#cart-footer .btn-prompt').show();
      $('[name="checkout"]').prop('disabled',true);
    }
  });
});

$('.enhanced-qty button').on('click', function(e){
  e.preventDefault();
  var $qty =  $(this).closest('.enhanced-qty').find('input');
  var currentQty = parseInt($qty.val());
  var updatedQty = currentQty + 1;
  if( $(this).hasClass('qty-down') ){
    updatedQty = currentQty - 1;
  }
  if( updatedQty < 0 ){
    updatedQty = 0;
  } 
  $qty.val(updatedQty).trigger('change');
});

$('#cart-announcement a').attr('target','_blank');

/*
Send users back to a relevant link from the cart
*/
var $continueLink = $('#cart-continue');
var lastCollectionPath = sessionStorage.getItem('saf_last_collection'); 
if ($continueLink.length && lastCollectionPath) {
  $continueLink.attr('href', window.location.origin + lastCollectionPath);
}